import { Component, OnInit, Input, ChangeDetectorRef, AfterViewInit, OnDestroy, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { CredentialDTO, User } from '../../class/user.class';
import { EncryptionDecryptionService } from '../../services/EncryptionDecryption.service';
import { AppModule } from '../../../app-module';
import { SessionStorageService } from '../../services/sessionl-storage.service';
import { ENV_TOKEN } from '../../../app-module.token';

@Component({
  selector: 'oaj-renueva-session-itx',
  templateUrl: './renuevaSession.component.html',
  styleUrls: ['./renuevaSession.component.css'],
  imports: [AppModule],
  providers: [AuthService, EncryptionDecryptionService]
})

export class RenuevaSessionComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() title: any;
  @Input() message: any;
  @Input() confirmText = 'Ok';
  @Input() cancelText = 'Cancel';

  loginForm!: FormGroup;
  submitted = false;
  returnUrl!: string;
  messageLogin!: string;
  usuarioNew: User = new User;
  TypeMessage!: string;
  loading = false;
  logeado = false;
  berror = false;

  userName!: string;
  timeLeft = 3;
  interval: number | undefined;
  private sessionStorageService: SessionStorageService = inject(SessionStorageService);
  public activeModal: NgbActiveModal = inject(NgbActiveModal);
  public changeRef: ChangeDetectorRef = inject(ChangeDetectorRef);
  private formBuilder: FormBuilder = inject(FormBuilder);
  private authService: AuthService = inject(AuthService);
  protected serviceED: EncryptionDecryptionService = inject(EncryptionDecryptionService);
  public constService: any;
  IPAddress = '';

  readonly environment = inject(ENV_TOKEN);
    constructor() {
        this.constService = this.environment;
    }

  ngOnInit() {

    this.loginForm = this.formBuilder.group({
      password: ['', Validators.required]
    });

      this.getIPAddress().then(success => {
            if (!success) {
                console.error('No se pudo obtener la dirección IP');
            }
        });

  }

  ngAfterViewInit() {
    this.startTimer();
  }

  ngOnDestroy() {
    this.timeLeft = 3;
    clearInterval(this.interval);
  }
  get f() { return this.loginForm.controls; }

  /**
   * Inicia el proceso de inicio de sesión para renovar la sesión, se valida el formulario, si es válido se encripta la contraseña ingresada, se crea un objeto de solicitud con el nombre de usuario actual, la contraseña encriptada y la dirección IP, luego se llama al servicio de autenticación para iniciar sesión con esta solicitud, si la respuesta es exitosa se actualiza el token en la sesión del usuario actual, si ocurre un error durante el inicio de sesión se muestra un mensaje de error
   * @returns 
   */
  login() {
    //  console.log('Renovar sesión');
    this.loading = true;
    this.submitted = true;
    this.logeado = false;
    this.messageLogin = '';
    this.TypeMessage = '';
    this.berror = false;

    this.userName = this.authService.getUserName();


    if (this.loginForm.invalid) {
      this.loading = false;
      return;
    } else {
      const { password } = this.loginForm.value;   
       const Passencrypted = this.serviceED.Encryption(password);
        const IPencrypted = this.serviceED.Encryption(this.IPAddress);
        const request: CredentialDTO = new CredentialDTO();
        request.User = this.userName;
        request.Password = Passencrypted;
        request.Ip = IPencrypted;
     // request.Password = password;

      this.authService.login(request).subscribe({
        next: (response: any) => {

          if (response.succeeded) {
            clearInterval(this.interval);
            const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
            if (currentUser) {
              if (currentUser.userName != response.account) {
                this.messageLogin = 'Las credenciales no corresponden al usuario actual';
                this.TypeMessage = 'error';
                this.loading = false;
                this.berror = true;
                this.changeRef.detectChanges();
              }
              else {
                let usuario: User = new User();
                usuario = currentUser;
                //Se actualiza el token en la sesión
                usuario.token = response.accessToken;
                this.sessionStorageService.setItem('currentUser', usuario);
                this.loading = false;
                this.logeado = true;
                this.activeModal.close(true);
                this.changeRef.detectChanges();
              }
            }

          }
          else {
            clearInterval(this.interval);
            this.messageLogin = 'Por favor, valida tu contraseña';
            this.TypeMessage = 'error';
            this.loading = false;
            this.berror = true;
            this.changeRef.detectChanges();
            return;
          }
        },
        error: (error) => {
          clearInterval(this.interval);
          console.error('error login:', error.message);
          this.messageLogin = 'Por favor, valida tu usuario y contraseña';
          this.TypeMessage = 'error';
          this.loading = false;
          this.berror = true;
          this.changeRef.detectChanges();
          return;
        }
      });

    }
  }

  /**
   * Inicia un temporizador para renovar la sesión, el temporizador se ejecuta cada 3 minutos (180000 ms) y decrementa el tiempo restante, si el tiempo llega a 0 se cierra la sesión del usuario, se cierra el modal y se limpia el temporizador
   * @returns
   */
  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.authService.logout();
        this.activeModal.close();
        clearInterval(this.interval);
      }
    }, 180000)
  }

  /**
   * Detiene el temporizador para renovar la sesión, se limpia el temporizador para evitar que siga ejecutándose
   */
  stopTimer() {
    clearInterval(this.interval);
  }

      /**
     * Funcion para obtener la dirección IP del usuario, se hace una consulta a un servicio externo para obtener la dirección IP pública del usuario, se encripta la dirección IP utilizando el servicio de encriptación y se asigna a la propiedad IPAddress, se resuelve la promesa con true si se obtiene la dirección IP correctamente o con false si ocurre un error durante la consulta
     * @returns 
     */
    getIPAddress(): Promise<boolean> {
        return new Promise((resolve) => {
            fetch(this.constService.ipAddress.URL_API)
                .then(respuestaRaw => respuestaRaw.json())
                .then(respuesta => {
                    this.IPAddress = respuesta.ip;
                    resolve(true);
                }, _error => {
                  const errorMessage = _error instanceof Error ? _error.message : String(_error);
                    console.error(errorMessage);
                    resolve(false);
                });
        });
    }


}

